import './paedml-card.tag'
import './paedml-modal-delete.tag'
import './paedml-icon.tag'
import './paedml-icon-modal.tag'
import './paedml-modal-createoredit-klassen.tag'
import './paedml-modal-info-klasse.tag'
import './paedml-modal-fix-perms-klassen.tag'

<paedml-card-klassenwartung>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings} ref='card'>
    
    <virtual if="{selectedExactlyOne()}">
      <paedml-icon-modal icon="fas-barcode" target="#{prefix}-see-modal" title="Klassen-Info ansehen" />
      <paedml-modal-info-klasse prefix="{prefix}-see" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Info" opname="OK" api={restApi} />
    </virtual>

    <virtual if="{canEdit()}">
      <paedml-icon-modal icon="bearbeiten" target="#{prefix}-edit-modal" title="Klasse bearbeiten" />
      <paedml-modal-createoredit-klassen prefix="{prefix}-edit" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Klasse bearbeiten" opname="Änderung speichern" api={restApi} />
    </virtual>

    <virtual if="{canDelete()}">
      <paedml-icon-modal icon="loeschen" target="#{prefix}-delete-modal" title="Klassen löschen" />
      <paedml-modal-delete idtextcol="7" patient="{{singular: 'Klasse', plural: 'Klassen', as: 'die'}}" heading="{config.contentTitle}: Klasse(n) löschen" 
        prefix="{prefix}-delete" selectedrowsfunc={getSelectedRows}
        api={restApi} relogin={true} doredirect={true}/>
    </virtual>

    <virtual if="{selectedOneOrMore() && isPermitted('cleanup')}">
      <paedml-icon-modal icon="fas-folder-open" target="#{prefix}-fix-modal" title="Tauschverzeichnis bearbeiten" />
      <paedml-modal-fix-perms-klassen idtextcol="7" prefix="{prefix}-fix" edit={true} selectedrowsfunc={getSelectedRows}
        variant="cleanup" heading="{config.contentTitle}: Tauschverzeichnis bearbeiten" opname="Korrekturen ausführen" api={restApi} />
    </virtual>

  </paedml-card>

  <script>
    import Session from '../store/session'

    this.session = Session

    this.prefix = opts.prefix

  </script>
</paedml-card-klassenwartung>
